<template>

  <!-- <div height="100vh"> -->
    <SideNavigationBar/>
    <router-view v-slot=" { Component }">
      <v-expand-transition ease-in>
        <component :is="Component"></component>
      </v-expand-transition>
    </router-view>
  <!-- </div> -->
  <!-- <Footer/> -->
</template>

<script>
import { defineComponent } from 'vue'

import SideNavigationBar from '@/components/SideNavigationBar.vue'
// import Footer from '@/components/Footer.vue'

export default defineComponent({
  name: 'DashboardView',

  components: {
    SideNavigationBar
    // Footer
  }
})
</script>

<style scoped>

</style>
